import { render, staticRenderFns } from "./print_wiq_ids.vue?vue&type=template&id=fa040b14&"
import script from "./print_wiq_ids.vue?vue&type=script&lang=js&"
export * from "./print_wiq_ids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports